import React, { Component } from 'react';
import { connect } from 'shalala';
import { Redirect } from 'react-router-dom';

import { useStore } from '../../store';
import PageHeader from '../../support/page-header/PageHeader';
import EmisorUpdateFiscalInfo from './upsert/EmisorUpdateFiscalInfo';
import GetNewListHighlighted from '../../support/GetNewListHighlighted';

class EmisoresUpdateFiscalInfo extends Component {
  state = {};

  constructor(props) {
    super(props);

    const { data = {} } = props.location.state || {};

    this.state = { data: data };
  }

  handleOnComplete = async (result) => {
    if (!!result) {
      window.ToastManager.show({
        variant: 'success',
        title: 'Registro',
        message: result.message || 'Información de Emisor actualizada',
      });

      const { data: emisores } = this.props.list;

      this._highlightUpsertedItem(emisores, result.data);

      this.props.history.replace('/app/emisores');
    }
  };

  _highlightUpsertedItem = (fullList, data) => {
    const newList = GetNewListHighlighted.make(fullList, data, true);

    this.props.listActions.setPartialState({ data: newList });

    setTimeout(() => {
      const newList = GetNewListHighlighted.make(fullList, data, false);

      this.props.listActions.setPartialState({ data: newList });
    }, 5000);
  };

  render() {
    const { data } = this.state;

    if (!data.id) {
      return <Redirect to="/app/emisores" />;
    }

    return (
      <>
        <PageHeader
          text="Regresar"
          to={`/app/emisores/${data.id}/info`}
        />

        <h5>{!!data.id && data.razon_social}</h5>

        <EmisorUpdateFiscalInfo
          data={data}
          onComplete={this.handleOnComplete}
        />
      </>
    );
  }
}

const mapState = (store) => {
  return { list: store.app.emisores.list };
};

const mapActions = (actions) => {
  return { listActions: actions.app.emisores.list };
};

export default connect(useStore, mapState, mapActions)(EmisoresUpdateFiscalInfo);
